import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  /**
   * Hello message
   */
  title = 'Questo Ã¨ il footer della card';

  /**
   * Add operation
   */
  add(a: number, b: number) {
    return a + b;
  }
}
